<template>
 <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 17.67 13.64">
| <title>Check</title>
\ <g id="Camada_2" data-name="Camada 2">
    <g id="Camada_1-2" data-name="Camada 1">
      <polygon class="cls-1" :fill="iconColor" points="4.59 11.88 0.15 7.25 1.85 5.47 6.29 10.11 4.59 11.88"/>
      <polygon class="cls-1" :fill="iconColor" points="17.52 1.93 6.28 13.64 4.58 11.87 15.82 0.15 17.52 1.93"/>
      <ellipse class="cls-1" :fill="iconColor" cx="1" cy="6.36" rx="1.23" ry="0.75" transform="translate(-4.37 2.81) rotate(-47.63)"/>
      <ellipse class="cls-1" :fill="iconColor" cx="16.67" cy="1.04" rx="0.75" ry="1.23" transform="translate(3.65 11.5) rotate(-42.37)"/>
    </g>
  </g>
 </svg>
</template>

<style lang="scss">
  
</style>
<script>
  export default {
    name: "Check",
     props: {
    iconName: {
      type: String,
      default: 'Check'
    },
    width: {
      type: [Number, String],
      default: 30
    },
    height: {
      type: [Number, String],
      default: 30
    },
    iconColor: {
      type: String,
      default: '#460d6c'
    }
  }
  }
</script>